import { render, staticRenderFns } from "./FeedBackOne.vue?vue&type=template&id=25becd10"
import script from "./FeedBackOne.vue?vue&type=script&lang=js"
export * from "./FeedBackOne.vue?vue&type=script&lang=js"
import style0 from "./FeedBackOne.vue?vue&type=style&index=0&id=25becd10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports